import { TIMEOUT } from "../../../constants";

export function getProgressAmount(startTime: number) {
    const currentTime = Date.now();
    const elapsedTime = currentTime - startTime;
    const pivotPercentage = 0.8; // The progress bar will fill up to 80% by the pivot time
    const progressBarPivotPoint = 60000; // 1 minute is the pivot point after which the progress bar will slow down

    if (elapsedTime >= TIMEOUT) {
        return 1;
    }

    if (elapsedTime <= progressBarPivotPoint) {
        // before pivot point, go fast
        return rounded((pivotPercentage / progressBarPivotPoint) * elapsedTime);
    }

    // after pivot point, go slow
    return rounded(
        pivotPercentage +
            ((1 - pivotPercentage) * (elapsedTime - progressBarPivotPoint)) /
                (TIMEOUT - progressBarPivotPoint)
    );
}

function rounded(decimal: number) {
    return Math.round(decimal * 1000) / 1000;
}
